<div class="signup-page">
  <!-- Arrière-plan animé -->
  <div class="animated-background">
    <div class="globe-container">
      <img src="assets/images/shape/shape-12.png" alt="Globe" class="globe rotating-globe" loading="lazy" />
      <div class="globe-ring ring-1"></div>
      <div class="globe-ring ring-2"></div>
      <div class="globe-ring ring-3"></div>
    </div>

    <!-- Objets flottants côté droit -->
    <div class="floating-objects">
      <img src="assets/images/shape/shape-34.png" alt="Bitcoin" class="floating-object bitcoin" loading="lazy" />
      <img src="assets/images/shape/shape-21.png" alt="Ethereum" class="floating-object ethereum" loading="lazy" />
      <img src="assets/images/shape/shape-20.png" alt="Chart" class="floating-object chart" loading="lazy" />
      <img src="assets/images/shape/shape-28.png" alt="Dollar" class="floating-object dollar" loading="lazy" />
      <img src="assets/images/shape/shape-14.png" alt="Graph" class="floating-object graph" loading="lazy" />
    </div>

    <!-- Particules lumineuses -->
    <div class="light-particles">
      <div class="light-particle particle-1"></div>
      <div class="light-particle particle-2"></div>
      <div class="light-particle particle-3"></div>
      <div class="light-particle particle-4"></div>
      <div class="light-particle particle-5"></div>
      <div class="light-particle particle-6"></div>
    </div>
  </div>

  <div class="container signup-container">
    <div class="row align-items-center min-vh-100">
      <!-- Formulaire d'inscription -->
      <div class="col-lg-5 col-md-6 mx-auto">
        <div class="signup-card card-custom fade-in-up">
          <div class="signup-header text-center mb-4">
            <h1 class="mb-2">Créer un compte</h1>
            <p class="text-secondary">Rejoignez la communauté de traders</p>
          </div>

          <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">

            <!-- Nom -->
            <div class="form-group mb-3">
              <label for="name" class="form-label">
                Nom complet <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-user"></i>
                <input type="text" id="name" class="form-control custom-input" placeholder="Votre nom complet"
                  formControlName="name" [class.is-invalid]="isFieldInvalid('name')" />
                <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
                  {{ getFieldError('name') }}
                </div>
              </div>
            </div>

            <!-- Sexe -->
            <div class="form-group mb-3">
              <label for="sex" class="form-label">
                Sexe <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-venus-mars"></i>
                <select id="sex" class="form-control custom-input" formControlName="sex"
                  [class.is-invalid]="isFieldInvalid('sex')">
                  <option value="" disabled>Sélectionnez un sexe</option>
                  <option value="F">Femme</option>
                  <option value="M">Homme</option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('sex')">
                  {{ getFieldError('sex') }}
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="form-group mb-3">
              <label for="email" class="form-label">
                Email <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-envelope"></i>
                <input type="email" id="email" class="form-control custom-input" placeholder="contact@example.com"
                  formControlName="email" [class.is-invalid]="isFieldInvalid('email')" />
                <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
                  {{ getFieldError('email') }}
                </div>
              </div>
            </div>

            <!-- Téléphone -->
            <div class="form-group mb-3">
              <label for="phone_number" class="form-label">
                Téléphone <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-phone"></i>
                <input type="tel" id="phone_number" class="form-control custom-input" placeholder="+33 6 12 34 56 78"
                  formControlName="phone_number" [class.is-invalid]="isFieldInvalid('phone_number')" />
                <div class="invalid-feedback" *ngIf="isFieldInvalid('phone_number')">
                  {{ getFieldError('phone_number') }}
                </div>
              </div>
            </div>

            <!-- Téléphone -->
            <div class="form-group mb-3">
              <label for="telegram_username" class="form-label">
                Username Telegram <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-phone"></i>
                <input type="text" id="telegram_username" class="form-control custom-input" placeholder="@jean_dratyn"
                  formControlName="telegram_username" [class.is-invalid]="isFieldInvalid('telegram_username')" />
                <div class="invalid-feedback" *ngIf="isFieldInvalid('telegram_username')">
                  {{ getFieldError('telegram_username') }}
                </div>
              </div>
            </div>

            <!-- Mot de passe -->
            <div class="form-group mb-3">
              <label for="password" class="form-label">
                Mot de passe <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-lock"></i>
                <input [type]="showPassword ? 'text' : 'password'" id="password" class="form-control custom-input"
                  placeholder="Mot de passe" formControlName="password"
                  [class.is-invalid]="isFieldInvalid('password')" />
                <button type="button" class="password-toggle" (click)="togglePasswordVisibility()" tabindex="-1">
                  <i [class]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                </button>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('password')">
                  {{ getFieldError('password') }}
                </div>
              </div>

              <!-- Force du mot de passe -->
              <div class="password-strength mt-2" *ngIf="signupForm.get('password')?.value">
                <div class="strength-bar">
                  <div class="strength-fill" [style.width.%]="passwordStrength" [class]="getPasswordStrengthClass()">
                  </div>
                </div>
                <small class="strength-label" [class]="getPasswordStrengthClass()">
                  {{ getPasswordStrengthLabel() }}
                </small>
              </div>
            </div>

            <!-- Confirmation -->
            <div class="form-group mb-3">
              <label for="confirmPassword" class="form-label">
                Confirmer mot de passe <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-lock-keyhole"></i>
                <input [type]="showConfirmPassword ? 'text' : 'password'" id="confirmPassword"
                  class="form-control custom-input" placeholder="Confirmer mot de passe"
                  formControlName="confirmPassword"
                  [class.is-invalid]="isFieldInvalid('confirmPassword') || signupForm.hasError('passwordMismatch')" />
                <button type="button" class="password-toggle" (click)="toggleConfirmPasswordVisibility()" tabindex="-1">
                  <i [class]="showConfirmPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                </button>
                <div class="invalid-feedback"
                  *ngIf="isFieldInvalid('confirmPassword') || signupForm.hasError('passwordMismatch')">
                  {{ getFieldError('confirmPassword') }}
                </div>
              </div>
            </div>


            <!-- Code parrainage toggle -->
            <div class="form-group mb-3">
              <a class="text-primary-color cursor-pointer fw-bold" (click)="toggleReferralCode()">
                J’ai un code de parrainage
              </a>
            </div>

            <!-- Champ code parrainage (conditionnel) -->
            <div class="form-group mb-3" *ngIf="showReferralCode">
              <label for="referral_code" class="form-label">
                Code de parrainage
              </label>
              <div class="input-wrapper">
                <i class="input-icon fa-solid fa-gift"></i>
                <input type="text" id="referral_code" class="form-control custom-input"
                  placeholder="Entrez votre code de parrainage" formControlName="referral_code" />
              </div>
            </div>

            <!-- Conditions -->
            <div class="form-group mb-4">
              <div class="form-check custom-checkbox">
                <input type="checkbox" class="form-check-input" id="acceptTerms" formControlName="acceptTerms"
                  [class.is-invalid]="isFieldInvalid('acceptTerms')" />
                <label class="form-check-label" for="acceptTerms">
                  En vous inscrivant, vous acceptez nos
                  <a routerLink="/conditions-utilisation" class="text-primary-color">Conditions d'utilisation</a> et
                  notre
                  <a routerLink="/politique-confidentialite" class="text-primary-color">Politique de confidentialité</a>
                </label>
              </div>
              <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('acceptTerms')">
                Vous devez accepter les conditions d'utilisation
              </div>
            </div>

            <!-- Bouton -->
            <button type="submit" class="btn btn-primary-custom w-100 mb-3" [disabled]="isLoading">
              <span *ngIf="!isLoading">S'inscrire</span>
              <span *ngIf="isLoading" class="d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Inscription en cours...
              </span>
            </button>

            <!-- Lien connexion -->
            <div class="text-center">
              <p class="mb-0 text-secondary">
                Vous avez déjà un compte ?
                <a (click)="onSignin()" class="text-primary-color cursor-pointer fw-bold">
                  Se connecter
                </a>
              </p>
            </div>

          </form>
        </div>
      </div>

      <!-- Section droite -->
      <div class="col-lg-6 d-none d-lg-block">
        <div class="promo-content fade-in slide-in-right">
          <h4 class="display-5 fw-bold mb-4">
            Immersion Totale<br>
            dans l'univers du trading<br>
            <span class="text-primary-color gradient-text">
              Crypto, Forex & Signaux professionnels
            </span>
          </h4>
          <p class="lead mb-4">
            Accédez à des formations expertes, des signaux fiables et des outils performants en cryptomonnaie et forex
            pour optimiser vos performances en toute sécurité.
          </p>
          <div class="cta-buttons mt-5">
            <button (click)="onSignin()" class="btn btn-primary-custom me-3">
              Commencer maintenant
            </button>
            <button (click)="onShowMore()" class="btn btn-outline-custom">
              Découvrir plus
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
